import {DeleteOutlined, EditOutlined, EyeOutlined, HolderOutlined, HomeOutlined, PlusOutlined, SyncOutlined, UploadOutlined, UserOutlined} from '@ant-design/icons';
import {DndContext} from '@dnd-kit/core';
import {restrictToVerticalAxis} from '@dnd-kit/modifiers';
import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {
  Alert,
  Badge,
  Breadcrumb,
  Button,
  Form,
  Input,
  Modal,
  Pagination,
  Popconfirm,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import PropTypes from 'prop-types';
import React, {useContext, useEffect, useMemo, useState} from 'react';
import toast from 'react-hot-toast';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {ReadMoreText} from '../../../commonComponents/ReadMoreText';
import SearchBar from '../../../commonComponents/SeachBar/SearchBar';
import {
  RQGetProductsByFilter,
  RqAddProduct,
  RqDeleteProduct,
  RqGetAllProducts,
  RqUpdateProduct,
} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {NewProductScreen} from './NewProductScreen';
import {ProductDetailScreen} from './ProductDetailScreen';
import {ProductEditScreen} from './ProductEditScreen';

const RowContext = React.createContext({});
const DragHandle = () => {
  const {setActivatorNodeRef, listeners} = useContext(RowContext);
  return (
    <Button
      type={'text'}
      size={'small'}
      icon={<HolderOutlined />}
      style={{cursor: 'move'}}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const Row = props => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({id: props['data-row-key']});
  const style = Object.assign(
    Object.assign(Object.assign({}, props.style), {
      transform: CSS.Translate.toString(transform),
      transition,
    }),
    isDragging ? {position: 'relative', zIndex: 9999} : {},
  );
  const contextValue = useMemo(
    () => ({setActivatorNodeRef, listeners}),
    [setActivatorNodeRef, listeners],
  );
  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

Row.propTypes = {
  'data-row-key': PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  style: PropTypes.object,
};

const Product = () => {
  const auth = useSelector(selectAuth);

  const token =auth?.tokenData;

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState(null);

  const [formTwo] = Form.useForm();

  const [dataSource, setDataSource] = useState([]);

  // const [productFilter, setProductFilter] = useState(null);
  const [jewelryTypeFilter, setJewelryTypeFilter] = useState(null);

  const [productTypeFilter, setProductTypeFilter] = useState(null);

  const [minPrice, setMinPrice] = useState(null); 

  const [imageFiles, setImageFiles] = useState([]); 
  const [previewUrls, setPreviewUrls] = useState([]); 

  const [editImageModal, setEditImageModal] = useState({visible: false, recordKey: null});

  const [editModal, setEditModal] = useState({visible: false, record: null});

  const [viewModal, setViewModal] = useState({visible: false, record: null});

  const [filters, setFilters] = useState();

  const [previewImagesModal, setPreviewImagesModal] = useState({
    visible: false,
    images: [],
  });
  const {Option} = Select;
  const filterConfig = {};
  if (jewelryTypeFilter) {filterConfig.productId = jewelryTypeFilter;}

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const onDragEnd = ({active, over}) => {
    if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
      setDataSource(prevState => {
        const activeIndex = prevState.findIndex(
          record => record.key === (active === null || active === void 0 ? void 0 : active.id),
        );
        const overIndex = prevState.findIndex(
          record => record.key === (over === null || over === void 0 ? void 0 : over.id),
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });
    }
  };
  useEffect(() => {
    setFilters(prev => {
      const updated = {...prev};
      if (minPrice !== undefined && minPrice !== null && minPrice !== '') {
        updated.minPrice = minPrice;
      } else {
        delete updated.minPrice;
      }
      return updated;
    });
  }, [minPrice]);

  const {
    data: filteredProductsData,
    refetch: refetchProducts,
    // isLoading: isLoadingFiltered,
  } = RQGetProductsByFilter(filters);
  const {
    data: allProdutcs,
  } = RqGetAllProducts();

  useEffect(() => {

    const hasFilters =
    filters?.jewelryType ||
    filters?.productType ||
    filters?.minPrice ||
    filters?.productName;

    const source = hasFilters ? filteredProductsData : allProdutcs;

    if (!source) {return;}

    const formatted = source.map((item, index) => ({
      key: item.id,
      id: item.id,
      index: index + 1,
      imageUrl: item.imageUrl,
      productName: item.productName,
      description: item.description,
      jewelryType: item.jewelryType,
      productType: item.productType,
      grossWeight: item.weight?.grossWeight || '',
      netWeight: item.weight?.netWeight || '',
      size: item.size || [],
      status: item.status,
    }));

    setDataSource(formatted);
    setCurrentPage(1);

  }, [filteredProductsData, allProdutcs, filters]);

  useEffect(() => {
    setFilters(prev => {
      const updated = {...prev};

      if (jewelryTypeFilter) {
        updated.jewelryType = jewelryTypeFilter;
      } else {
        delete updated.jewelryType;
      }

      if (productTypeFilter) {
        updated.productType = productTypeFilter;
      } else {
        delete updated.productType;
      }

      return updated;
    });
  }, [jewelryTypeFilter, productTypeFilter]);

  const data = dataSource;
  const pageSizeOptions = ['10', '20', '30', '50'];
  const paginatedData = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const isEditing = record => record.key === editingKey;

  const showModal = () => setIsModalVisible(true);

  const handleCancel = () => setIsModalVisible(false);

  const {data: userData, isLoading, error} = RqGetAllProducts();

  const addProductMutation = RqAddProduct();

  const handleChange = value => {
    console.log(`selected ${value}`);
  };

  const handleFormSubmit = values => {
    const {productName, description, grossWeight, netWeight, jewelryType, productType, price, size} = values;

    if (!imageFiles.length) {
      message.error('Please upload at least one image.');
      return;
    }

    const productData = {
      productName,
      description,
      jewelryType,
      productType,
      weight: {
        grossWeight,
        netWeight,
      },
      size: size.map(item => ({
        size: item.size,
        quantity: item.quantity.toString(),
        price: String(item.price), 
      })),
      status: 'ACTIVE',
    };

    const formData = new FormData();
   
    formData.append(
      'command',
      new Blob([JSON.stringify(productData)], {type: 'application/json'}),
    );
    
    imageFiles.forEach(file => {
      formData.append('images', file);
    });

    addProductMutation.mutate(
      {token,  productData: formData},
      {
        onSuccess: () => {
          toast.success('Product added successfully!');
          setIsModalVisible(false);
          form.resetFields();
          refetchProducts();
          setImageFiles([]);
          setPreviewUrls([]);
        },
        onError: () => {
          message.error('Error uploading product');
        },
      },
    );
  };

  const handleModalImageUpload = async ({file}) => {
 
    setImageFiles(prev => [...prev, file]);
   
    const previewUrl = URL.createObjectURL(file);
    setPreviewUrls(prev => [...prev, previewUrl]);
  };

  const updateProductMutation = RqUpdateProduct({
    onSuccess: () => {
      toast.success('Product updated successfully');
      setEditingKey(null);
    },
    onError: error => {
      toast.error('Failed to update product');
      console.error('Update error:', error);
    },
  });

  const openEditModal = record => {
    setEditModal({visible: true, record});
    setImageFiles(record.imageUrl || []);
    formTwo.setFieldsValue(record);
  };
 
  //DELETE FUNCTIONALITY 
  const deleteProductMutation = RqDeleteProduct({
    onSuccess: () => {
      toast.success('Product deleted successfully');
      handleCancel(); 
    },
    onError: err => {
      toast.error(err.message || 'Failed to delete product');
    },
  });
  
  const handleDelete = async id => {
    try {
      await deleteProductMutation.mutateAsync({token, id});
    } catch (err) {
     
      console.error(err);
    }
  };
  const columns = [
    {key: 'sort', align: 'center', width: 40, render: () => <DragHandle />},
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: 'Image',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (imageUrls, record) => {
        const urls = Array.isArray(imageUrls) ? imageUrls : [imageUrls];
        const count = urls.filter(Boolean).length;

        return (
          <>
            <button
              onClick={() => {
                setEditImageModal({visible: true, recordKey: record.key, record});
                setImageFiles(record.imageUrl || []);
              }}
              className={'p-0 border-none bg-transparent cursor-pointer relative group'}
              style={{outline: 'none'}}
              aria-label={'Edit product images'}
            >
              <Badge count={count} offset={[-5, 5]} style={{backgroundColor: '#001529'}}>
                <div className={'relative w-16 h-16'}>
                  <img
                    src={urls[0]}
                    alt={'thumbnail'}
                    className={'w-full h-full object-cover rounded transition group-hover:brightness-75'}
                  />
                  <EyeOutlined
                    className={'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg opacity-0 group-hover:opacity-100 transition'}
                  />
                </div>
              </Badge>
            </button>

            <Modal
              title={'Edit Images'}
              width={'40vw'}
              styles={{
                body: {maxHeight: '40vh', overflowY: 'auto'},
              }}
              open={editImageModal.visible && editImageModal.recordKey === record.key}
              onCancel={() => {
                setEditImageModal({visible: false, recordKey: null, record: null});
                setImageFiles([]);
              }}
              onOk={async () => {

                // separate existing urls from new files
                const existingUrls = imageFiles.filter(img => typeof img === 'string');
                const newFiles = imageFiles.filter(img => img instanceof File);

                const updatedProduct = {
                  productName: record.productName,
                  description: record.description,
                  size: record.size,
                  weight: {
                    grossWeight: record.grossWeight,
                    netWeight: record.netWeight,
                  },
                  jewelryType: record.jewelryType,
                  productType: record.productType,
                  
                  imageUrl: existingUrls,
                };

                const formData = new FormData();

                formData.append(
                  'command',
                  new Blob([JSON.stringify(updatedProduct)], {
                    type: 'application/json',
                  }),
                );

                // only files here
                newFiles.forEach(file => {
                  formData.append('images', file);
                });

                updateProductMutation.mutate({
                  token,
                  id: record.id,
                  formData,
                });

                setEditImageModal({
                  visible:false,
                  recordKey:null,
                  record:null,
                });

                setImageFiles([]);
              }}
            >
              <div className={'flex flex-wrap gap-3 mb-3'}>

                {imageFiles.map((img, idx) => {
                  const preview =
      typeof img === 'string'
        ? img
        : URL.createObjectURL(img);

                  return (
                    <div
                      key={idx}
                      className={'relative w-[90px] h-[90px] border rounded-lg overflow-hidden group'}
                    >
                      <img
                        src={preview}
                        alt={'preview'}
                        className={'w-full h-full object-cover'}
                      />

                      {/* delete button */}
                      <Button
                        size={'small'}
                        danger
                        icon={<DeleteOutlined />}
                        className={'absolute top-1 right-1 opacity-0 group-hover:opacity-100'}
                        onClick={() => {
                          setImageFiles(prev =>
                            prev.filter((_, i) => i !== idx),
                          );
                        }}
                      />

                    </div>
                  );
                })}

                {/* upload button tile */}
                <ImgCrop rotationSlider>
                  <Upload
                    accept={'image/*'}
                    multiple
                    showUploadList={false}
                    beforeUpload={file => {

                      setImageFiles(prev => [...prev, file]);

                      return false;
                    }}
                  >
                    <div className={'w-[90px] h-[90px] border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-blue-500'}>
                      <UploadOutlined style={{fontSize: 22}} />
                    </div>
                  </Upload>
                </ImgCrop>

              </div>

              <ImgCrop rotationSlider>
                <Upload
                  accept={'image/*'}
                  multiple
                  showUploadList={false}
                  beforeUpload={file => {

                    setImageFiles(prev => [...prev, file]);

                    const preview = URL.createObjectURL(file);
                    setPreviewUrls(prev => [...prev, preview]);

                    return false; // prevent auto upload
                  }}
                >
                  {/* <Button type={'primary'} icon={<UploadOutlined />}>
    Upload Image
                  </Button> */}
                </Upload>
              </ImgCrop>
            </Modal>
          </>
        );
      },
    },
    {
      title: 'Name',
      dataIndex: 'productName',
      key: 'productName',
      width: 200,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'productName'} style={{margin: 0}}>
            <Input className={'whitespace-normal break-words max-w-xs'} />
          </Form.Item>
        ) : (
          <div className={'whitespace-normal break-words max-w-xs'}>
            {record.productName}
          </div>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 400,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'description'} style={{margin: 0}}>
            <Input.TextArea rows={3} />
          </Form.Item>
        ) : (
          <ReadMoreText text={record.description} maxLength={150} />
        );
      },
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      render: (_, record) => (
        Array.isArray(record.size) ? (
          <Space direction={'vertical'}>
            {record.size.map((item, index) => (
              <Tag key={index}
                className={'w-auto'}
                color={item.quantity <= 5 ? 'red' : 'blue'}
              >
                      Size: {item.size}, Qty: {item.quantity} , Price: {item.price}
              </Tag>
            ))}
          </Space>
        ) : (
          JSON.stringify(record.size)
        )
      ),
    },
    // {
    //   title: 'price',
    //   dataIndex: 'price',
    //   key: 'price',
    //   render: (_, record) => (
    //     Array.isArray(record.price) ? (
    //       <Space direction={'vertical'}>
    //         {record.price.map((item, index) => (
    //           <Tag key={index}
    //             className={'w-auto'}
    //             color={item.quantity <= 5 ? 'red' : 'blue'}
    //           >
    //                   price: {item.price}
    //           </Tag>
    //         ))}
    //       </Space>
    //     ) : (
    //       JSON.stringify(record.price)
    //     )
    //   ),
    // },
    {title: 'Gross wt', dataIndex: 'grossWeight', key: 'grossWeight',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'grossWeight'} style={{margin: 0}}>
            <Input />
          </Form.Item>
        ) : (
          record.grossWeight
        );
      },
    },
    {title: 'Net wt', dataIndex: 'netWeight', key: 'netWeight',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'netWeight'} style={{margin: 0}}>
            <Input />
          </Form.Item>
        ) : (
          record.netWeight
        );
      },
    },
    {title: 'Category', dataIndex: 'jewelryType', key: 'jewelryType',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'jewelryType'} style={{margin: 0}}>
            <Input />
          </Form.Item>
        ) : (
          record.jewelryType
        );
      },
    },
    {title: 'Product', dataIndex: 'productType', key: 'productType',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'productType'} style={{margin: 0}}>
            <Input />
          </Form.Item>
        ) : (
          record.productType
        );
      },
    },
    // {title: 'Price', dataIndex: 'price', key: 'price',
    //   render: (_, record) => {
    //     const editable = isEditing(record);
    //     return editable ? (
    //       <Form.Item name={'price'} style={{margin: 0}}>
    //         <Input />
    //       </Form.Item>
    //     ) : (
    //       record.price
    //     );
    //   },
    // },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Tooltip title={'Edit'}>
            <Button
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
            />
          </Tooltip>
          <Tooltip title={'View'}>
            <Button
              icon={<EyeOutlined />}
              onClick={() => setViewModal({visible: true, record})}
            />
          </Tooltip>
          <Tooltip title={'Delete'}>
            <Popconfirm
              title={'Are you sure you want to delete this item?'}
              onConfirm={() => handleDelete(record.id)}
              okText={'Yes'}
              cancelText={'No'}
            >
              <Button danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>

        </Space>
      ),
    },

  ];

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const handleSearch = (searchText = '') => {
    const cleanedText = searchText.trim().toLowerCase();
    console.log('cleanedText >>>>', cleanedText);
    const filters = {
      productName: cleanedText,
    };
    setFilters(filters);
  };

  if (!token) {
    message.error('Token missing. Please login again.');
    return;
  }

  if (isLoading) {
    return(
      <div className={'flex justify-center items-center'}>
        <Spin size={'large'} />
      </div>
    );}

  if (error) {
    return <Alert message={'Failed to load users'} type={'error'} />;
  }

  return(
    <div>
      <Breadcrumb className={'md:flex hidden mb-6'}
        items={[
          {
            href: '/dashboard',
            title: <HomeOutlined />,
          },
          {
            href: '/product',
            title: (
              <>
                <UserOutlined />
                <span>product</span>
              </>
            ),
          },
        ]}
      />
      <div className={'flex lg:flex-row flex-col justify-between'}>
        <div className={'flex lg:flex-row flex-col gap-2 justify-content items-start mb-4 w-2/3 '}>  
          <SearchBar onSearch={handleSearch} placeholder={'Search products...'} />
          <Select
            placeholder={'Filter by jewelry type'}
            allowClear
            showSearch
            value={jewelryTypeFilter || undefined}
            onChange={value => setJewelryTypeFilter(value)}
            options={
              [...new Set(userData?.map(product => product.jewelryType))].map(type => ({
                label: type,
                value: type,
              })) || []
            }
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{width: 250}}
          />
          <Select
            placeholder={'Filter by product type'}
            allowClear
            showSearch
            value={productTypeFilter || undefined}
            onChange={value => setProductTypeFilter(value)}
            options={
              [...new Set(userData?.map(product => product.productType))].map(type => ({
                label: type,
                value: type,
              })) || []
            }
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{width: 250}}
          />
        </div>
        <div className={'flex justify-end'}>
          <Button
            type={'primary'}
            icon={<PlusOutlined />}
            onClick={showModal}
            className={'w-36'}
          >
          Add New Product
          </Button>
        </div>
      </div>
      <div className={'flex justify-center items-center mt-2 w-full'}>
        <div className={'md:w-full lg:max-w-full overflow-x-auto'}>
          <Form form={formTwo} component={false}>
            <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
              <SortableContext items={dataSource.map(i => i.key)} strategy={verticalListSortingStrategy}>
                <Table
                  tableLayout={'fixed'}
                  components={{body: {row: Row}}}
                  size={'middle'}
                  scroll={{x: 'max-content'}}
                  columns={columns}
                  dataSource={paginatedData}
                  rowKey={'key'}
                  pagination={false}
                />
              </SortableContext>
            </DndContext>
            <div className={'flex justify-between items-center mt-4 px-2'}>
              
              <Select
                value={String(pageSize)}
                onChange={value => {
                  setPageSize(Number(value));
                  setCurrentPage(1);
                }}
                style={{width: 120}}
              >
                {pageSizeOptions.map(size => (
                  <Option key={size} value={size}>
                    {size} / page
                  </Option>
                ))}
              </Select>

              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={data.length}
                showSizeChanger={false}
                onChange={page => setCurrentPage(page)}
              />
            </div>
            <NewProductScreen isModalVisible={isModalVisible}
              handleModalImageUpload={handleModalImageUpload}
              setPreviewUrls={setPreviewUrls}
              addProductMutation={addProductMutation}
              setEditModal={setEditModal}
              form={form}
              previewUrls={previewUrls}
              updateProductMutation={updateProductMutation}
              token={token}
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              dataSource={paginatedData}
              setDataSource={setDataSource}
              handleChange={handleChange}
              handleCancel={handleCancel}
              handleFormSubmit={handleFormSubmit}
            />
            <ProductEditScreen editModal={editModal}
              setEditModal={setEditModal}
              form={formTwo}
              updateProductMutation={updateProductMutation}
              token={token}
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              dataSource={dataSource}
              setDataSource={setDataSource}
              handleChange={handleChange}
            />
            <ProductDetailScreen viewModal={viewModal} setViewModal={setViewModal} />
          </Form>
        </div>
      </div>
    </div>
  );
};

Product.propTypes = {
  'data-row-key': PropTypes.string,
  style: PropTypes.object,

};

export default Product;
